import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { perTnsSalarieOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'per-effective-date',
    templateUrl: './per-effective-date.component.html',
    styleUrls: ['./per-effective-date.component.scss'],
    standalone: false
})
export class PerEffectiveDateComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  perTnsSalarieOptions = perTnsSalarieOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setStepName('perEffectiveDate');
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
